// Rezervasyon kaydından misafir adı üretme — tek doğru kaynak.
//
// DİKKAT: `GET api/rezervasyonlar` RezervasyonDto döndürür ve bu DTO'da
// `misafirAdi` diye bir alan YOKTUR. İsim iç içe gelir:
//
//   rezervasyonMisafirler[].misafir.adSoyad
//
// Konaklayan misafir seçen her ekran bu dosyayı kullanmalı; `r.misafirAdi`
// okuyan kod sessizce boş sonuç verir.

/**
 * Rezervasyondaki misafirlerin adlarını " / " ile birleştirir.
 * @param {object} r  RezervasyonDto
 * @param {string} bos  hiç misafir yoksa dönecek değer
 */
export function rezMisafirAdi(r, bos = '') {
  return r?.rezervasyonMisafirler
    ?.map(m => m.misafir?.adSoyad)
    .filter(Boolean)
    .join(' / ') || bos;
}

/**
 * Rezervasyondaki ilk misafirin adı — tek isim gereken yerler için
 * (havuz girişi, hizmet randevusu gibi tek kişilik kayıtlar).
 */
export function rezIlkMisafirAdi(r, bos = '') {
  return r?.rezervasyonMisafirler
    ?.map(m => m.misafir?.adSoyad)
    .find(Boolean) || bos;
}

/**
 * Arama için düzleştirilmiş metin: misafir adları + oda no + rezervasyon no.
 * Türkçe küçük harfe çevrilir, çağıran taraf da aynı şekilde çevirmelidir.
 */
export function rezAramaMetni(r) {
  return [rezMisafirAdi(r), r?.odaNo, r?.rezNo]
    .filter(Boolean)
    .join(' ')
    .toLocaleLowerCase('tr-TR');
}
